import { render } from "./RcpIntegrationsApp.vue?vue&type=template&id=18579a7f"
import script from "./RcpIntegrationsApp.vue?vue&type=script&lang=js"
export * from "./RcpIntegrationsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__